export function P3(props) {
  return <p className="pd-paragraph-p3">{props.children}</p>;
}

export default P3;
